/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Duplicate_ColumnsInputs */

const en_ledger_error_duplicate_columns = /** @type {(inputs: Ledger_Error_Duplicate_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The query returns duplicate column names`)
};

const nl_ledger_error_duplicate_columns = /** @type {(inputs: Ledger_Error_Duplicate_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De query geeft dubbele kolomnamen terug`)
};

/**
* | output |
* | --- |
* | "The query returns duplicate column names" |
*
* @param {Ledger_Error_Duplicate_ColumnsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_duplicate_columns = /** @type {((inputs?: Ledger_Error_Duplicate_ColumnsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Duplicate_ColumnsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_duplicate_columns(inputs)
	return en_ledger_error_duplicate_columns(inputs)
});